import API_BASE_URL from '../config/api';

const authHeaders = () => {
  const token =
    typeof localStorage !== 'undefined' ? localStorage.getItem('token') : null;
  return token ? { Authorization: `Bearer ${token}` } : {};
};

export async function listPromos(params = new URLSearchParams()) {
  const url = new URL(`${API_BASE_URL}/promos`);
  for (const [k, v] of params.entries()) url.searchParams.set(k, v);
  const res = await fetch(url.toString(), { headers: { ...authHeaders() } });
  const json = await res.json();
  if (!res.ok) throw new Error(json?.message || 'Failed to load promos');
  return json;
}

export async function createPromo(payload) {
  const res = await fetch(`${API_BASE_URL}/promos`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...authHeaders() },
    body: JSON.stringify(payload),
  });
  const json = await res.json();
  if (!res.ok) throw new Error(json?.message || 'Failed to create promo');
  return json?.data || json;
}

export async function validatePromo(code, cartTotal) {
  const url = new URL(
    `${API_BASE_URL}/promos/validate/${encodeURIComponent(code)}`
  );
  if (typeof cartTotal === 'number')
    url.searchParams.set('cartTotal', String(cartTotal));
  const res = await fetch(url.toString());
  const json = await res.json();
  if (!res.ok) throw new Error(json?.message || 'Invalid promo');
  return json?.data || json;
}
